import React, { useEffect } from "react";
import { inject, observer } from 'mobx-react';
import MaterialTable, { MTableToolbar } from "material-table";
import ReportsMenu from '../ReportsMenu';
import { TableOptions, gcpColumns, localization } from '../Constants';
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner'
import { RenderGCPDetails } from "../HelperFunctionsReporting"
import '../Reporting.css';
import Grid from "@material-ui/core/Grid";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Typography, IconButton } from '@material-ui/core';
import { HtmlTooltip } from "../../HtmlTooltip/HtmlTooltip";

const GCP = inject('RootStore')(observer(({ RootStore }) => {
  useEffect((() => {
    RootStore.reportingStore.setRenderSpinner(true)
    RootStore.reportingStore.getGCPReport()
  }), [RootStore.reportingStore]);

  return (
    <div className="row">
      {RootStore.reportingStore.renderSpinner && <LoadingSpinner text='Loading report' />}
      <ReportsMenu />
      <div className="col-sm-9" id="report-table">
        <div>
          {<MaterialTable
            title=""
            data={RootStore.reportingStore.gcpAccounts}
            columns={gcpColumns}
            options={TableOptions}
            localization={localization}
            onRowClick={(event, rowData, togglePanel) => togglePanel()}
            detailPanel={[
              {
                tooltip: 'Show Acc',
                render: rowData => RenderGCPDetails(rowData),
              }
            ]}
            components={{
              Toolbar: (props) => (
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={3}
                >
                  <Grid item sm={3}>
                    <h4 style={{ marginLeft: '10px' }}>
                      GCP Report
                    </h4>
                  </Grid>
                  <Grid item sm={4} style={{ textAlign: 'right' }}>
                    <h4>{new Date(RootStore.accountStore.oldestGCPUpdatedDate).toUTCString()}</h4>
                    ({new Date(RootStore.accountStore.oldestGCPUpdatedDate).toLocaleString()} local time)
                  </Grid>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit" variant="caption">
                          This is GCP's last successful update date.
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <IconButton aria-label="delete" size="small">
                      <HelpOutlineIcon fontSize="inherit" />
                    </IconButton>
                  </HtmlTooltip>
                  <Grid item sm={4} style={{ textAlign: 'left' }}>
                    <MTableToolbar {...props} />
                  </Grid>
                </Grid>
              )
            }}
          />}
        </div>
      </div>
    </div>
  )
}));

export default GCP;


